import { Breadcrumbs, Typography } from "@mui/material";
import Link from "@mui/material/Link";
import { Link as RouterLink, useLocation, useSearchParams } from "react-router-dom";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { useSelector } from "react-redux";
import { useTheme } from "@emotion/react";
import { StyledBreadcrumbsContainer } from "./AppBreadcrumbs.styled";
import { BreadCrumbData } from "@shared/lib/navigation/Breadcrumbs.types";
import { getBreadcrumbsData } from "@shared/lib/navigation/breadcrumbs";
import { parseDocumentSettingsIdToNumber } from "@features/documents/utils/documentSettings";
import { DocumentSettings } from "@models/document-settings";
import { RootState } from "@app/store";

function AppBreadcrumbs() {
  const theme = useTheme();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const documentSettingsId: number | null = parseDocumentSettingsIdToNumber(searchParams.get("documentType"));

  const documentsSettings: DocumentSettings[] | undefined = useSelector(
    (state: RootState) => state.documents.settings,
  );

  const breadcrumbs: React.ReactNode[] = createBreadcrumbs(
    getBreadcrumbsData(
      location.pathname,
      documentsSettings?.find((settings) => settings.id === documentSettingsId),
      location.state?.breadcrumbData,
    ),
  );

  function createBreadcrumbs(breadcrumbData: BreadCrumbData[]): React.ReactNode[] {
    return breadcrumbData.map((item: BreadCrumbData, index: number) =>
      index !== breadcrumbData.length - 1 && item.link ? (
        <Link
          component={RouterLink}
          to={item.link || ""}
          underline="hover"
          key={index}
          state={{
            ...item.state,
            breadcrumbData: breadcrumbData.slice(0, index + 1),
          }}
          sx={{
            color: theme.colors.input_border_color,
            "&:visited": { color: theme.colors.input_border_color },
            "&:hover": { color: theme.colors.input_border_color },
            "&:active": { color: theme.colors.input_border_color },
          }}
        >
          {item.name}
        </Link>
      ) : (
        <Typography key={index} sx={{ color: theme.colors.input_border_color }}>
          {item.name}
        </Typography>
      ),
    );
  }

  return (
    <StyledBreadcrumbsContainer>
      <Breadcrumbs
        separator={<NavigateBeforeIcon sx={{ color: theme.colors.input_border_color }} fontSize="small" />}
        aria-label="breadcrumb"
      >
        {breadcrumbs}
      </Breadcrumbs>
    </StyledBreadcrumbsContainer>
  );
}

export default AppBreadcrumbs;
